import React from 'react'
import Moment from 'react-moment'

const TodayDate = () => {
  return (
    <div className="text-xl text-slate-500">
        <Moment locale="id" format="dddd, DD/MM/YYYY"></Moment>
    </div>
  )
}

export default TodayDate